import React from "react";

const Clickable = ({ disabled, href, ...props }) => {
  if (disabled) {
    return <div {...props} />;
  }
  if (href) {
    return <a href={href} {...props} />;
  }
  return <a role="button" tabIndex={0} {...props} />;
};

export default Clickable;
